import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import Plotly from 'plotly.js/dist/plotly-cartesian';
import { connect } from 'react-redux';

import workerScript from './WebWorker/worker.js';

import { removeStreamer } from './../../../../actions/closeLoop/apmDashboard/streamerActions';
import { includeResource } from './../../../../actions/closeLoop/apmDashboard/listResourcesActions';
import PropTypes from "prop-types";


function StreamingContainer(props) {
    const [webWorker] = useState(new window.Worker(workerScript));

    // CPU & RAM Utilization Data initialization
    const data = [{
        x: [''],
        y: [0],
        mode: 'lines',
        line: {color: '#80CAF6'},
        name: "CPU Utilization (%)"
    },{
        x: [''],
        y: [0],
        mode: 'lines',
        line: {color: '#DF56F1'},
        name: "RAM Utilization (%)"
    }];

    // CPU & RAM Utilization Layout configuration.
    const layout = {
        title: "CPU & RAM Utilization",
        xaxis: {
            title: "Time (s)",
            type: "date"
        },
        yaxis: {
            title: "CPU & RAM Utilization (%)"
        }
    };

    // CPU, RAM & RAM Memory Usage plot configuration.
    const config = {
        showLink: false,
        displayModeBar: true,
        displaylogo: false,
        responsive: true,
        useResizeHandler: true,
        autosize: true,
        width: "100%",
        height: "100%",
        showLegend: true
    };

    // RAM Memory Usage Data initialization.
    const memData = [{
        x: [''],
        y: [0],
        mode: 'lines',
        line: {color: '#80CAF6'},
        name: "RAM Memory Usage"
    }];

    // RAM Memory Usage Layout configuration.
    const memLayout = {
        title: "RAM Memory Usage",
        xaxis: {
            title: "Time (s)",
            type: "date"
        },
        yaxis: {
            title: "RAM Memory Usage (MB)"
        }
    };

    useEffect(() => {
        // CPU & RAM Utilization
        Plotly.newPlot(props.resource, data, layout, config);
        // Memory Usage
        Plotly.newPlot(`${props.resource}-mem-usage`, memData, memLayout, config);

        const eventData = {
            dockerName: props.resource,
            dnsName: window.location.origin,
            instanceId: props.selectedInstance
        };
        webWorker.postMessage(eventData);

        webWorker.onmessage = (event) => {
            if(event.data) {
                // CPU Utilization;
                const data = event.data;
                const cpuPerc = data['cpu_perc'];
                const updatedTime = data['timestamp'];
                // Date & Time;
                const currentTime = new Date(Number(updatedTime) * 1000);
                // Memory RAM Utilization;
                const memPerc = data['mem_perc'];

                // CPU & RAM Utilization (%)
                const update = {
                    x: [[ currentTime ], [ currentTime ]],
                    y: [[Number(cpuPerc.replace('%', ''))],
                        [Number(memPerc.replace('%', ''))]]
                };

                // RAM memory usage;
                const memUsage = data['mem_usage'].replaceAll(' ', '');
                const usage = memUsage.split('/');
                let memValue = usage;
                if(usage.includes('GiB')) {
                    memValue = Number(memValue.replace("GiB", "")) * 1024;
                } else if(usage.includes("MiB")) {
                    memValue = usage.replace("MiB", "");
                } else {
                    memValue = usage;
                }

                // RAM Memory Usage (MiB)
                const memUpdate = {
                    x: [[currentTime]],
                    y: [[memValue]]
                };

                // Plot traces for both CPU & RAM utilization.
                Plotly.extendTraces(props.resource, update, [0, 1]);

                // Plot trace for RAM Memory Usage;
                Plotly.extendTraces(`${props.resource}-mem-usage`, memUpdate, [0]);
            }
        }
    }, [])

    useEffect(() => {
        return () => {
            webWorker.terminate();
            console.log("Terminated the worker", props.resource);
        }
    }, [])

    const removeStreamContainer = () => {
        props.addResource(props.resource);
        props.removeStream(props.resource);
    };
    console.log("removeStreamContainer", removeStreamContainer)

    return (
        <>
            <Container>
                <Card>
                <Card.Header>
                    <Row>
                        <Col xs lg={10}>
                            <h2>{props.resource}</h2>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <div
                                id={props.resource}
                            ></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div
                                id={`${props.resource}-mem-usage`}
                                style={{ display: "none" }}
                            ></div>
                        </Col>
                    </Row>
                </Card.Body>
                </Card>
            </Container>
        </>
    )
}

const mapStateToProps = (state) => ({
    selectedInstance: state.instances.selectedInstance
})

const mapDispatchToProps = (dispatch) => ({
    removeStream: (payload) => dispatch(removeStreamer(payload)),
    addResource: (payload) => dispatch(includeResource(payload))
});

StreamingContainer.propTypes = {
    resource: PropTypes.string,
    selectedInstance: PropTypes.string,
    addResource: PropTypes.func,
    removeStream: PropTypes.func,

};
StreamingContainer.defaultProps = {
    resource: '',
    selectedInstance: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(StreamingContainer);